import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback } from 'react';
import BaseDropdown from '../BaseDropdown/BaseDropdown.js';
import '../BaseDropdown/types.js';
import '../BaseDropdown/components/VirtualizedMenuList.js';
import Components from './components/index.js';
import DropdownProvider from './context/DropdownProvider.js';
import useOptionsStyles from './hooks/useOptionStyles.js';

const createNoneItem = (label) => ({ label, value: null, isNone: true });
const Dropdown = (_a) => {
    var { options = [], size, startComponent, noneLabel = 'None', withNoneOption, onCreate, getCreateLabel = 'Create label', disableHighlighting, isDisabled, 'data-testid': testId, onMenuClose, onMenuOpen, components, footer } = _a, rest = __rest(_a, ["options", "size", "startComponent", "noneLabel", "withNoneOption", "onCreate", "getCreateLabel", "disableHighlighting", "isDisabled", 'data-testid', "onMenuClose", "onMenuOpen", "components", "footer"]);
    const [isOpen, setIsOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const alteredOptions = useMemo(() => {
        let updatedOptions = [...options];
        if (noneLabel && !!options.length && withNoneOption) {
            updatedOptions = [createNoneItem(noneLabel), ...updatedOptions];
        }
        return updatedOptions;
    }, [withNoneOption, noneLabel, options]);
    const onMenuOpenInternal = useCallback(() => {
        setIsOpen(true);
        onMenuOpen === null || onMenuOpen === void 0 ? void 0 : onMenuOpen();
    }, [onMenuOpen]);
    const onMenuCloseInternal = useCallback(() => {
        setIsOpen(false);
        onMenuClose === null || onMenuClose === void 0 ? void 0 : onMenuClose();
    }, [onMenuClose]);
    const styles = useOptionsStyles({ size });
    const alteredComponents = useMemo(() => (Object.assign(Object.assign({}, Components), components)), 
    // NOTE: This eslint warning was disabled in order to enable a pre-push hook. It doesn't mean that the warning isn't
    // valid. Whoever touches this code, please try removing the eslint-disable-next-line comment and fix the problem.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (jsx(DropdownProvider, Object.assign({ size: size, onCreate: onCreate, disableHighlighting: disableHighlighting, getCreateLabel: getCreateLabel, "data-testid": testId, footer: footer }, { children: jsx(BaseDropdown, Object.assign({}, rest, { startComponent: startComponent, size: size, isMulti: false, isDisabled: isDisabled, onInputChange: setInputValue, getOptionValue: a => {
                if ('value' in a)
                    return a.value;
            }, options: alteredOptions, inputValue: inputValue, components: alteredComponents, isOpen: isOpen, onMenuOpen: onMenuOpenInternal, onMenuClose: onMenuCloseInternal, styles: styles, "data-testid": testId })) })));
};

export { Dropdown as default };
//# sourceMappingURL=Dropdown.js.map
